
import React from 'react'
import {
  Container,
  Row,
  Col,
  Button,
  Modal,
  Form,
  Table,
  Nav,
  Tab,
  Breadcrumb
} from "react-bootstrap";
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

function AssignedViewRoom() {
  const userDetailsLocal = localStorage.getItem('userDetails');
  const userDetailsLo = JSON.parse(userDetailsLocal);
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const data = location.state;
  const bread = data.from
  console.log("data", data);
  console.log("data", data);


  return (
    <Container fluid>
      <Row className='m-0'>
        <Col sm={1} >
          <Tab.Container  >
            <Row>
            </Row>
          </Tab.Container>
        </Col>
        <Col sm={11}>

          <Row className="px-5 py-2 ">
            <hr />
            <Row className="d-flex justify-content-end col-sm-5 w-auto">
              <Breadcrumb>
                <Breadcrumb.Item

                  style={{
                    fontSize: "13px",
                    fontWeight: "bold",
                    color: "#333",
                    textTransform: "uppercase",
                    letterSpacing: "-0.5px",
                    backgroundColor: "#ea6e2b",
                    borderRadius: "0 20px 20px 0", // Rounded left, sharp right
                    height: 30,
                    width: 'auto',
                    paddingRight: "10px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer", // Pointer on hover
                    marginLeft: "10px",

                    // Hover effect
                    ":hover": {
                      backgroundColor: "#FFA500", // Change background color on hover
                      transform: "scale(1.1)", // Slightly increase the size on hover
                      boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)", // Enhance shadow on hover
                    }
                  }} onClick={() =>
                    navigation("/assigned")
                  } >Assigne Project</Breadcrumb.Item>
                <Breadcrumb.Item
                  style={{
                    fontSize: "13px",
                    fontWeight: "bold",
                    color: "#333",
                    textTransform: "uppercase",
                    letterSpacing: "-0.5px",
                    backgroundColor: "#ea6e2b",
                    borderRadius: "0 20px 20px 0", // Rounded left, sharp right
                    height: 30,
                    width: 'auto',
                    paddingRight: "10px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer", // Pointer on hover
                    marginLeft: "10px",

                    // Hover effect
                    ":hover": {
                      backgroundColor: "#FFA500", // Change background color on hover
                      transform: "scale(1.1)", // Slightly increase the size on hover
                      boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)", // Enhance shadow on hover
                    }
                  }}
                  onClick={() => { navigation("/assigned/view-rooms", { state: data }) }}
                >
                  {data.pname}
                </Breadcrumb.Item>
                <Breadcrumb.Item
                  style={{
                    fontSize: "13px",
                    fontWeight: "bold",
                    color: "#333",
                    textTransform: "uppercase",
                    letterSpacing: "-0.5px",
                    backgroundColor: "#ea6e2b",
                    borderRadius: "0 20px 20px 0", // Rounded left, sharp right
                    height: 30,
                    width: 'auto',
                    paddingRight: "10px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer", // Pointer on hover
                    marginLeft: "10px",

                    // Hover effect
                    ":hover": {
                      backgroundColor: "#FFA500", // Change background color on hover
                      transform: "scale(1.1)", // Slightly increase the size on hover
                      boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)", // Enhance shadow on hover
                    }
                  }} active>View Design</Breadcrumb.Item>
              </Breadcrumb>
            </Row>
            <hr />
            {/* Room name and type modal */}
            <Row className="p-2" style={{ backgroundColor: "#F2F2F2", height: 'auto', overflowY: 'auto' }}>

              <Row>

                <Col
                  sm={12}
                >
                  <Container>
                    <Row>
                      <Col style={{ minHeight: 380, maxHeight: 480 }}>
                        <h4>Room Details</h4>
                        <Row className=" border-bottom border-dark">
                          <Col><h6>Name </h6></Col>
                          <Col><h6>Material</h6></Col>
                          <Col><h6>Width</h6></Col>
                          <Col><h6>Height/length</h6></Col>
                          <Col><h6>Area/RFT</h6></Col>
                          <Col><h6>Base Price</h6></Col>
                          <Col><h6>Quantity</h6></Col>
                          <Col><h6>Price</h6></Col>
                          <Col><h6>Remark</h6></Col>
                        </Row>
                        {data?.viewData?.title && Array.isArray(data.viewData.title) ? data.viewData.title.map((item, index) => {
                          const price = Number(item.price) || 0;
                          const val = Number(item.value) || 0;
                          const isShape = item.name === "Shape Of Kitchen";
                          const hasContent = price > 0 || val > 0 || isShape || Boolean(item.label) || Boolean(item.remark);

                          if (hasContent && (price > 0 || val > 0 || isShape)) {
                            const w = parseFloat(item.width);
                            const h = parseFloat(item.height);
                            const computedArea = item.area
                              ? item.area
                              : (!isNaN(w) && !isNaN(h) && w > 0 && h > 0)
                                ? (w * h).toFixed(2).replace(/\.00$/, '')
                                : (item.rft || '');

                            return (
                              <Row key={index} className="border-bottom border-dark-subtle p-2">
                                <Col><h6>{item.name} {item.label2 ? `  (${item.label2})` : null}</h6></Col>
                                <Col><h6>{item.label || '-'}</h6></Col>
                                <Col><h6>{item.width || '-'}</h6></Col>
                                <Col><h6>{item.height || '-'}</h6></Col>
                                <Col><h6>{computedArea || '-'}</h6></Col>
                                <Col><h6>{item.value || 0}</h6></Col>
                                <Col><h6>{item.qnty ? item.qnty : '-'}</h6></Col>
                                <Col><h6>{item.price || 0}</h6></Col>
                                <Col><h6>{item.remark || '-'}</h6></Col>
                              </Row>
                            );
                          }
                          return null;
                        }) : null}

                      </Col>

                    </Row>

                  </Container>

                </Col>
              </Row>


            </Row>


            {/* Bedroom modal */}

          </Row>

        </Col>
      </Row>
    </Container>
  )
}

export default AssignedViewRoom


